<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-7">
				<sf-card class="p-0 h-100 card_bg">
					<pwa-apcn-search
						ref="pwaApcnSearch"
						:scrId="scrId"
						:pStartDt="pStartDt"
						:pEndDt="pEndDt"
						:pState1="pState1"
						:pState2="pState2"
						:pState3="pState3"
					/>
				</sf-card>
			</div>
			<!--엑셀 업로드 팝업창 영역 시작-->
			<div class="sf-col sf-col-17">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<pwa-apcn-table ref="table" @PopupOpen="PopupOpen" @PopupRoOpen="PopupRoOpen" @Refresh="Refresh" :scrId="scrId" />
					<pwa-apcn-popup ref="pwaApcnPopup" @Refresh="Refresh" :scrId="scrId" />
					<ro-apcn-popup ref="roApcnPopup" @Refresh="Refresh" :scrId="scrId" />
				</sf-card>
			</div>
			<!--엑셀 업로드 팝업창 영역 끝-->
		</div>
	</div>
</template>

<script>
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../store/helpers';
import PwaApcnSearch from './Search/PwaApcnSearch.vue'; //PWA신청현황
import PwaApcnTable from './Table/PwaApcnTable.vue'; //PWA 신청현황
import PwaApcnPopup from './PwaApcnPopup/PwaApcnPopup.vue'; //PWA 신청현황팝업
import RoApcnPopup from '@mqy/ceqi/RoApcn/Content/RoApcnPopup/RoApcnPopup.vue'; //Ro 신청현황팝업


export default {
	props: {
		scrId: { type: String, default: '' },
		pStartDt: { type: String, default: '' }, //클레임 승인현황에서 시작일자 가져옴
		pEndDt: { type: String, default: '' }, //클레임 승인현황에서 종료일자 가져옴
		pState1: { type: String, default: '' }, //클레임 승인현황에서 처리단계 가져옴
		pState2: { type: String, default: '' }, //클레임 승인현황에서 처리결과 가져옴
		pState3: { type: String, default: '' } //클레임 승인현황에서 날짜 검색조건 가져옴
	},
	async created() {
		try {
			this.setState_({key: 'isMqyStation', value: await this.inclManyUsrGrp_(['MQYSS'])});
			//console.log('-----',this.isMqyStation);
		} catch (error) {
			this.$sf_toast({ type: 'error', message: error?.message || error });
		} finally {
			this.$sf_toggleLoading(false);
		}
	},
	computed: {
		...qmsComputed,
		...rootComputed,
		...serviceComputed
	},
	components: { PwaApcnSearch, PwaApcnTable, PwaApcnPopup, RoApcnPopup },
	methods: {
		...qmsMethods,
		...rootMethods,
		...serviceMethods,
		Refresh() {
			//$refs 는 컴포넌트에 ref로 정의한 이름으로 접근할때 사용한다.
			this.$refs.pwaApcnSearch.searchList();
		},
		PopupOpen(param) {
			//this.userName = param.userName;
			//console.log('ContentView 에서의 param값 ::::: ', param);

			this.$refs.pwaApcnPopup.open(param); //ExcelUploadModal 팝업에 정의한 open팝업을 실행한다.
		},
		PopupRoOpen(param) {
			//alert('여기호출');

			this.$refs.roApcnPopup.open(param); // 팝업에 정의한 open팝업을 실행한다.
		}
	}
};
</script>

<style></style>
